import { createSlice } from '@reduxjs/toolkit'

export const pdfSlice = createSlice({
  name: 'pdf',
  initialState: {
    title: 'Piano sheets',
    description: 'Learn to play the song nocturne',
    files: [],
    fontFamily: 'Arial, sans-serif',
    titleColor: '#000000', // New
    descriptionColor: '#000000', // New
    buttonTextColor: '#ffffff', // New
    buttonBackgroundColor: '#5e59fe', // New
    cardBackgroundColor: '#ffffff' // New
  },
  reducers: {
    setPDFField(state, action) {
      state[action.payload.key] = action.payload.val
    },
    setPDFFile(state, action) {
      state.files[0] = action.payload
    },
    initializePDF(state, action) {
      state.title = 'Piano sheets'
      state.description = 'Learn to play the song nocturne'
      state.files = []
      state.fontFamily = 'Arial, sans-serif'
      state.titleColor = '#000000'
      state.descriptionColor = '#000000'
      state.buttonTextColor = '#ffffff'
      state.buttonBackgroundColor = '#5e59fe'
      state.cardBackgroundColor = '#ffffff'
    }
  }
})

export const {
  setPDFField,
  setPDFFile,
  initializePDF
} = pdfSlice.actions
export default pdfSlice.reducer